import { render, staticRenderFns } from "./VerificationFormDocuments.vue?vue&type=template&id=de0a41ca&"
import script from "./VerificationFormDocuments.vue?vue&type=script&lang=js&"
export * from "./VerificationFormDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports